/**
 * Values Card Sort — 60-card vocabulary, DE + EN.
 *
 * The list mirrors the prototype at `Step 1 - DISCOVER/Values-Card-Sort.html`
 * and is the canonical pool for STP-026. Pairs are aligned by index:
 * `VALUES_DE[i]` translates `VALUES_EN[i]`.
 *
 * Versioning rule (CFG-129): once a value is published, never rename or
 * delete it — `card_sort_results` rows reference values by name. Add
 * new values to the bottom; never reorder existing ones.
 *
 * Indices 0-59 below define the canonical ordering of v1 of the pool.
 */

export const VALUES_EN: readonly string[] = [
  'Achievement',          // 0
  'Adventure',            // 1
  'Authenticity',         // 2
  'Autonomy',             // 3
  'Balance',              // 4
  'Beauty',               // 5
  'Belonging',            // 6
  'Boldness',             // 7
  'Calmness',             // 8
  'Challenge',            // 9
  'Clarity',              // 10
  'Compassion',           // 11
  'Connection',           // 12
  'Contribution',         // 13
  'Courage',              // 14
  'Creativity',           // 15
  'Curiosity',            // 16
  'Discipline',           // 17
  'Empathy',              // 18
  'Energy',               // 19
  'Excellence',           // 20
  'Fairness',             // 21
  'Faith',                // 22
  'Family',               // 23
  'Forgiveness',          // 24
  'Freedom',              // 25
  'Friendship',           // 26
  'Generosity',           // 27
  'Gratitude',            // 28
  'Growth',               // 29
  'Health',               // 30
  'Honesty',              // 31
  'Hope',                 // 32
  'Humility',             // 33
  'Humor',                // 34
  'Independence',         // 35
  'Integrity',            // 36
  'Intimacy',             // 37
  'Joy',                  // 38
  'Justice',              // 39
  'Kindness',             // 40
  'Leadership',           // 41
  'Learning',             // 42
  'Love',                 // 43
  'Loyalty',              // 44
  'Mastery',              // 45
  'Meaning',              // 46
  'Patience',             // 47
  'Peace',                // 48
  'Perseverance',         // 49
  'Play',                 // 50
  'Presence',             // 51
  'Resilience',           // 52
  'Responsibility',       // 53
  'Service',              // 54
  'Simplicity',           // 55
  'Trust',                // 56
  'Truth',                // 57
  'Wisdom',               // 58
  'Wonder',               // 59
];

export const VALUES_DE: readonly string[] = [
  'Leistung',             // 0 — Achievement
  'Abenteuer',            // 1 — Adventure
  'Authentizität',        // 2 — Authenticity
  'Autonomie',            // 3 — Autonomy
  'Balance',              // 4 — Balance
  'Schönheit',            // 5 — Beauty
  'Zugehörigkeit',        // 6 — Belonging
  'Mut',                  // 7 — Boldness
  'Gelassenheit',         // 8 — Calmness
  'Herausforderung',      // 9 — Challenge
  'Klarheit',             // 10 — Clarity
  'Mitgefühl',            // 11 — Compassion
  'Verbundenheit',        // 12 — Connection
  'Beitrag',              // 13 — Contribution
  'Tapferkeit',           // 14 — Courage
  'Kreativität',          // 15 — Creativity
  'Neugier',              // 16 — Curiosity
  'Disziplin',            // 17 — Discipline
  'Empathie',             // 18 — Empathy
  'Energie',              // 19 — Energy
  'Exzellenz',            // 20 — Excellence
  'Fairness',             // 21 — Fairness
  'Glaube',               // 22 — Faith
  'Familie',              // 23 — Family
  'Vergebung',            // 24 — Forgiveness
  'Freiheit',             // 25 — Freedom
  'Freundschaft',         // 26 — Friendship
  'Großzügigkeit',        // 27 — Generosity
  'Dankbarkeit',          // 28 — Gratitude
  'Wachstum',             // 29 — Growth
  'Gesundheit',           // 30 — Health
  'Ehrlichkeit',          // 31 — Honesty
  'Hoffnung',             // 32 — Hope
  'Demut',                // 33 — Humility
  'Humor',                // 34 — Humor
  'Unabhängigkeit',       // 35 — Independence
  'Integrität',           // 36 — Integrity
  'Intimität',            // 37 — Intimacy
  'Freude',               // 38 — Joy
  'Gerechtigkeit',        // 39 — Justice
  'Güte',                 // 40 — Kindness
  'Führung',              // 41 — Leadership
  'Lernen',               // 42 — Learning
  'Liebe',                // 43 — Love
  'Loyalität',            // 44 — Loyalty
  'Meisterschaft',        // 45 — Mastery
  'Bedeutung',            // 46 — Meaning
  'Geduld',               // 47 — Patience
  'Frieden',              // 48 — Peace
  'Beharrlichkeit',       // 49 — Perseverance
  'Spiel',                // 50 — Play
  'Präsenz',              // 51 — Presence
  'Resilienz',            // 52 — Resilience
  'Verantwortung',        // 53 — Responsibility
  'Dienst',               // 54 — Service
  'Einfachheit',          // 55 — Simplicity
  'Vertrauen',            // 56 — Trust
  'Wahrheit',             // 57 — Truth
  'Weisheit',             // 58 — Wisdom
  'Staunen',              // 59 — Wonder
];

export const VALUES_POOL_VERSION = 'values-pool-v1';
